import { v4 as uuid } from 'uuid'
class Service {
  constructor(messageChannel) {
    this.messageChannel = messageChannel
    this.observers = new Map()
  }
  /**
     * Подписаться на событие и вернуть метод для отписки
     *
     * @protected
     * @param {string} messageType
     * @param {Function} fn
     * @return {*}  {UnsubscribeFunction}
     * @memberof Service
     *
     * @example
     * const log = (...args) => console.log(...args)
     *
     * const unsubscribe = this.subscribe('test', log)
     * unsubscribe()
     */
  subscribe(messageType, fn) {
    var _a
    if (!this.observers.has(messageType)) {
      this.observers.set(messageType, new Set())
    }
    (_a = this.observers.get(messageType)) === null || _a === void 0 ? void 0 : _a.add(fn)
    return this.unsubscribe.bind(this, messageType, fn)
  }
  /**
     * Отправить событие
     *
     * @protected
     * @param {string} messageType
     * @param {...any} args
     * @memberof Service
     */
  broadcast(messageType, ...args) {
    var _a
    if (this.observers.has(messageType)) {
      (_a = this.observers.get(messageType)) === null || _a === void 0 ? void 0 : _a.forEach((subscriber) => {
        subscriber(...args)
      })
    }
  }
  unsubscribe(messageType, fn) {
    var _a
    if (this.observers.has(messageType)) {
      const result = this.observers.get(messageType).delete(fn)
      if (((_a = this.observers.get(messageType)) === null || _a === void 0 ? void 0 : _a.size) === 0) {
        this.observers.delete(messageType)
      }
      return result
    }
    return false
  }
  /**
     * Выполнить асинхронный запрос к API
     *
     * @protected
     * @param {*} message
     * @param {*} waiters
     * @return {*}  {Promise<any>}
     * @memberof Service
     */
  execute(message, waiters) {
    return new Promise((resolve, reject) => {
      waiters.push({
        reject,
        resolve,
      })
      this.messageChannel.send(message)
    })
  }
  /**
     * @ignore
     */
  resolve(waiters, message) {
    waiters.forEach((waiter) => {
      waiter.resolve(message)
    })
  }
  /**
     * @ignore
     */
  reject(waiters, message) {
    waiters.forEach((waiter) => {
      waiter.reject(message)
    })
  }
  /**
     * @ignore
     */
  uuid() {
    return uuid()
  }
}
export default Service
